import styled from "@emotion/styled";

import { useDragOperation } from "@skilitics/drag-drop";

const MenuSection = styled.div`
  flex: 1 1 auto;
  padding-bottom: 1rem;
  position: relative;
`;

const MenuHeadline = styled.div`
  font-weight: bold;
  margin-right: 10px;
`;

// Enabled by setting showDndDebugInfo to true in OrderableItem.tsx
// This is useful for understanding what the current collisions are while dragging items.

export const DEBUGResponseDnd = () => {
  const { source, target } = useDragOperation();
  return (
    <MenuSection key="Debug">
      <MenuHeadline>Active:</MenuHeadline>
      <div>
        <label>Active ID: {source?.id}</label>
        <pre style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{JSON.stringify(source?.data)}</pre>
      </div>
      <MenuHeadline>Over:</MenuHeadline>
      <div>
        <label>Over ID: {target?.id}</label>
        <pre style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{JSON.stringify(target?.data)}</pre>
      </div>
    </MenuSection>
  );
};
